import { useRMSelector } from 'redux/hooks';

export const useSetupTabOption = () => {
  return useRMSelector((state) => state.setupTab.setupTabOption);
};

export const useSetupImageStore = () => {
  return useRMSelector((state) => state.setupTab.imageStores);
};
